<div class="organize">

  <!-- ── Page header ─────────────────────────────────────────────────────── -->
  <ui-page-header
    [title]="'organize.organize' | translate"
    lucideIcon="LayoutGrid">
  </ui-page-header>

  <!-- ── Level 1 tabs ────────────────────────────────────────────────────── -->
  <div class="organize__tabs">
    <div class="organize__tab" role="tab"
      [attr.aria-selected]="activeTab === 'brands'"
      [class.active]="activeTab === 'brands'"
      (click)="onTabChange('brands')">
      {{ 'brands.brands' | translate }}
    </div>
    <div class="organize__tab" role="tab"
      [attr.aria-selected]="activeTab === 'categories'"
      [class.active]="activeTab === 'categories'"
      (click)="onTabChange('categories')">
      {{ 'Categories.categories' | translate }}
    </div>
    <div class="organize__tab" role="tab"
      [attr.aria-selected]="activeTab === 'tags'"
      [class.active]="activeTab === 'tags'"
      (click)="onTabChange('tags')">
      {{ 'Labels.labels' | translate }}
    </div>
  </div>

  <!-- ── Active tab content ──────────────────────────────────────────────── -->
  <div class="organize__content">
    <router-outlet
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
    ></router-outlet>
  </div>

</div>
